import React, { useEffect, useState } from "react";
import "./LoginPage.css"; // Include your custom styles
import { Link, Navigate, useNavigate } from "react-router-dom";
import Notification from "../../components/Common/Notification";
import ActivityLoader from "../../components/Common/ActivityLoader";
import ajaxAuth from "../../util/remote/ajaxAuth";
const LoginPage = () => {


  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [notify, setNotify] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(()=>{
      if(!loading && notify){
          setTimeout(() => {
              setNotify(false);
          }, 5000);
      }
  }, [notify])


 const handleLogin = async(event) =>{
    
      event.preventDefault();
      if(username.length < 1 || password.length < 1){
          setNotify(<Notification message="Complete all fields" type='danger'/>);
          return;
      }
      setLoading(true);
      const server_response = await ajaxAuth.login(username, password);
      setLoading(false);
      setNotify(<div className='mb-3'><ActivityLoader /></div> )
      if(server_response.status === "OK"){
          setNotify(<Notification message={server_response.message} type='success'/>);
          localStorage.setItem('eschool@user', server_response.details.token);
          navigate('/dashboard')
          window.location.reload();
      }else{
          setNotify(<Notification message={server_response.message} type='danger'/>);
      }
 }

 const isLoggedIn = localStorage.getItem('eschool@user');

 if (isLoggedIn) {
     return <Navigate to="/dashboard" />;
 }


  const handleSignup = () => {
    navigate('/signup');
  }

  return (
    <div className="content">
      <div className="container">
        <div className="row">
          {/* Left Image Section */}
          <div className="col-md-6">
            {/* Logo Section */}
            <div className="text-left mb-4">
                  <img
                    src="assets/images/logo.svg" // Replace with your logo's path
                    alt="yexp logo"
                    className="logo"
                    style={{ maxWidth: "60px", height: "auto", position: 'absolute'}} // Adjust size as needed
                  />
                </div>
            <img
              src="assets/images/undraw_remotely_2j6y.svg"
              alt="Illustration"
              className="img-fluid"
            />
          </div>

          {/* Right Login Section */}
          <div className="col-md-6 contents">
            <div className="row justify-content-center">
              <div className="col-md-8">
                

                {/* Login Form */}
                <div className="mb-4">
                  <h3>Sign In</h3>
                  <p className="mb-4">
                   Enter your eSchool Username and Password to access your account.
                  </p>
                </div>
                <form action="#" method="post" onSubmit={handleLogin}>
                  {notify}
                  <div className={`form-group first ${username.length > 0 ? 'field--not-empty': ''}`}>
                    <label htmlFor="username">Username</label>
                    <input
                      type="text"
                      className="form-control"
                      onChange={(e)=>setUsername(e.target.value)}
                      value={username}
                      required
                      id="username"
                    />
                  </div>
                  <div className={`form-group las mb-4 ${password.length > 0 ? 'field--not-empty': ''}`}>
                    <label htmlFor="password">Password</label>
                    <input
                      type="password"
                      className="form-control"
                      onChange={(e)=>setPassword(e.target.value)}
                      value={password}
                      required
                      id="password"
                    />
                  </div>
                  <div className="d-flex mb-5 align-items-center">
                    <label className="control control--checkbox mb-0">
                      <span className="caption">Remember me</span>
                      <input type="checkbox" defaultChecked />
                      <div className="control__indicator"></div>
                    </label>
                    <span className="ml-auto">
                      <Link to="/forgot-password" className="forgot-pass">
                        Forgot Password
                      </Link>
                    </span>
                  </div>
                  <input
                    type="submit"
                    value="Log In"
                    className="btn btn-block btn-primary"
                  />
                  <span className="d-block text-left my-4 text-muted">
                    &mdash; or get started &mdash;
                  </span>
                  <button className="btn btn-block btn-light" onClick={handleSignup}>Sign Up</button>
                  
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
